import { authHTTP } from "./axios.service";

export { getKdrAsPDF, getKdrAsEmail };

function getKdrAsPDF(payload) {
  return authHTTP({
    method: "GET",
    url: "/exams/" + payload.id + "/kdr/pdf/",
    responseType: "blob"
  });
}

function getKdrAsEmail(payload) {
  return authHTTP({
    method: "GET",
    url: "/exams/" + payload.id + "/kdr/email/"
  });
}
